import { ReferralRevenueData } from 'types/marketplace/revenue';
import { ExcelMultiDataSet } from 'types/react-export-excel';

export const referralRevenueDataToExcelMultiDataSet = (
  data: ReferralRevenueData,
): ExcelMultiDataSet[] => {
  const { total, sales } = data;

  const {
    refereeCount,
    itemCount,
    totalSales,
    revenueRate,
    totalRevenue,
  } = total;

  return [
    {
      columns: [
        { value: 'Referrer Info', widthPx: 80 },
        { value: '', widthPx: 80 },
        { value: 'Referral Info', widthPx: 60 },
        { value: '', widthPx: 60 },
        { value: '', widthPx: 60 },
        { value: 'Revenue rate', widthPx: 60 },
        { value: '', widthPx: 60 },
        { value: '', widthPx: 60 },
        { value: '', widthPx: 60 },
      ],
      data: [],
    },
    {
      columns: [
        'Referrer Name',
        'Account',
        'Users',
        'Items',
        'Total Sales',
        'Revenue rate',
        'Total Revenue',
      ],
      data: [
        [
          'total',
          '',
          refereeCount,
          itemCount,
          totalSales,
          revenueRate,
          totalRevenue,
        ],
        ...(sales?.map(
          ({
            sellerName,
            email,
            refereeCount,
            itemCount,
            sales,
            revenueRate,
            revenue,
          }) => [
            sellerName,
            email,
            refereeCount,
            itemCount,
            sales,
            revenueRate,
            revenue,
          ],
        ) ?? []),
      ],
    },
  ];
};
